import React from 'react';
import PropTypes from 'prop-types';
import { Button, FormControl, Modal, Table } from 'react-bootstrap';
import StepNav from './StepNav.jsx';

const AddProjectModalXer = ({
	steps,
	step,
	hasFile,
	confirmAndClose,
	next,
	addProjectXerFileChange
}) => {
	return (
		<React.Fragment>
			<Modal.Body>
				<StepNav steps={steps} step={step} />
				<Table className="projectSetupTable">
					<tbody>
						<tr>
							<td>Choose a schedule file</td>
							<td>
								<FormControl
									componentClass="input"
									onChange={addProjectXerFileChange}
									type="file"
									accept=".xer,.xml,application/xml,text/xml"
									label="Schedule File" />
								<div className="help-block" style={{ marginTop: 8, fontSize: 12 }}>
									Primavera P6 <code>.xer</code> or MS Project XML (File → Save As → XML). Binary <code>.mpp</code> is not supported.
								</div>
							</td>
						</tr>
					</tbody>
				</Table>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={confirmAndClose} bsStyle="danger" className="floatLeft">Cancel</Button>
				<Button bsStyle="primary" onClick={next} disabled={!hasFile}>Next</Button>
			</Modal.Footer>
		</React.Fragment>
	);
};

AddProjectModalXer.propTypes = {
	steps: PropTypes.array,
	step: PropTypes.number,
	hasFile: PropTypes.bool,
	confirmAndClose: PropTypes.func,
	next: PropTypes.func,
	addProjectXerFileChange: PropTypes.func
};

export default AddProjectModalXer;